import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Historial de compras", -1)
const _hoisted_2 = { key: 1 }

import TableComponent from '@/components/PortalComponents/TableComponent.vue';
    import { IShopping } from '@/interfaces/IShopping';
    import { useRouter } from 'vue-router';
    import { useShoppingStore } from '@/stores/shopping';
    import swal from 'sweetalert';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingHistoryView',
  setup(__props) {

    const router = useRouter();
    const ShoppingStore = useShoppingStore();

    const showTable = () => ShoppingStore.showTable

    const editItem = async( item: IShopping ) => {
        console.log(item)
        if ( await ShoppingStore.fetchSingleData(item.Com_codigo)) {
            router.push({name: 'editSale', params: {id: ShoppingStore.singleData.Com_codigo}})
            // Actualizar la tabla
            ShoppingStore.fetchDataList()
        } else {
            console.log("Error, no se pudo obtener el item")
        }
    }

    const deleteItem = async ( item: IShopping ) => {
        console.log(item)
        if (await ShoppingStore.deleteData(item)) {
            // Actualizar la tabla
            console.log("Item eliminado")
            swal("¡Genial!", "Se ha eliminado exitosamente", "success")
            ShoppingStore.fetchDataList()
        } else {
            console.log("Error, no se pudo borrar el item")
            swal("Error", "No se pudo borrar el item", "error")
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (showTable())
      ? (_openBlock(), _createBlock(TableComponent, {
          key: 0,
          headers: _unref(ShoppingStore).headers,
          data: _unref(ShoppingStore).dataList,
          onDeleteCurrentRow: deleteItem,
          onEditCurrentRow: editItem
        }, null, 8, ["headers", "data"]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_2, "Todavía no hay compras, puedes agregar usando los botones de arriba"))
  ]))
}
}

})